var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 22,
    viewBox: "0 0 45 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11C0.5 5.20101 5.20101 0.5 11 0.5H34C39.799 0.5 44.5 5.20101 44.5 11C44.5 16.799 39.799 21.5 34 21.5H11C5.20101 21.5 0.5 16.799 0.5 11Z",
    fill: "#F4F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11C0.5 5.20101 5.20101 0.5 11 0.5H34C39.799 0.5 44.5 5.20101 44.5 11C44.5 16.799 39.799 21.5 34 21.5H11C5.20101 21.5 0.5 16.799 0.5 11Z",
    stroke: "#D9D6FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19664_1472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65159 6.12891C4.02319 6.9465 3.54934 7.88884 3.27344 8.91256H7.43525L4.65159 6.12891Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7243 8.91253C18.4483 7.88884 17.9745 6.9465 17.3461 6.12891L14.5625 8.91253H18.7243Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27344 13.0869C3.54938 14.1106 4.02322 15.0529 4.65159 15.8705L7.43516 13.0869H3.27344Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8696 4.65358C15.052 4.02517 14.1097 3.55133 13.0859 3.27539V7.43717L15.8696 4.65358Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 17.3451C6.94259 17.9735 7.88494 18.4473 8.90863 18.7233V14.5615L6.125 17.3451Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90859 3.27539C7.88491 3.55133 6.94256 4.02517 6.125 4.65355L8.90859 7.43714V3.27539Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 18.7233C14.1096 18.4473 15.052 17.9735 15.8695 17.3451L13.0859 14.5615V18.7233Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 13.0869L17.3461 15.8705C17.9745 15.053 18.4483 14.1106 18.7243 13.0869H14.5625Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9323 9.95653H12.0435H12.0435V3.06772C11.7019 3.02325 11.3537 3 11 3C10.6463 3 10.2981 3.02325 9.95653 3.06772V9.95647V9.9565H3.06772C3.02325 10.2981 3 10.6463 3 11C3 11.3537 3.02325 11.7019 3.06772 12.0435H9.95647H9.9565V18.9323C10.2981 18.9768 10.6463 19 11 19C11.3537 19 11.7019 18.9768 12.0435 18.9323V12.0435V12.0435H18.9323C18.9768 11.7019 19 11.3537 19 11C19 10.6463 18.9768 10.2981 18.9323 9.95653Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 13.0879L16.6558 16.6578C16.82 16.4937 16.9766 16.3221 17.1261 16.1442L14.0698 13.0879H13.0859V13.0879Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91366 13.0879H8.91359L5.34375 16.6577C5.50787 16.8219 5.67947 16.9785 5.85734 17.128L8.91366 14.0716V13.0879Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91512 8.91274V8.91268L5.34525 5.34277C5.18106 5.5069 5.02444 5.67849 4.875 5.85637L7.93134 8.91271H8.91512V8.91274Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 8.9132L16.6558 5.34327C16.4917 5.17908 16.3201 5.02245 16.1423 4.87305L13.0859 7.92939V8.9132Z",
    fill: "#D80027"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6216 6.27273V15H26.3006V7.59375H26.2494L24.1614 8.95739V7.69602L26.3389 6.27273H27.6216ZM32.6607 15.1449C31.9874 15.142 31.4122 14.9645 30.9349 14.6122C30.4576 14.2599 30.0925 13.7472 29.8397 13.0739C29.5869 12.4006 29.4604 11.5895 29.4604 10.6406C29.4604 9.6946 29.5869 8.88636 29.8397 8.21591C30.0954 7.54545 30.4619 7.03409 30.9391 6.68182C31.4193 6.32955 31.9931 6.15341 32.6607 6.15341C33.3283 6.15341 33.9008 6.33097 34.3781 6.68608C34.8553 7.03835 35.2204 7.54972 35.4732 8.22017C35.7289 8.88778 35.8568 9.6946 35.8568 10.6406C35.8568 11.5923 35.7303 12.4048 35.4775 13.0781C35.2247 13.7486 34.8596 14.2614 34.3823 14.6165C33.905 14.9688 33.3312 15.1449 32.6607 15.1449ZM32.6607 14.0071C33.2516 14.0071 33.7133 13.7188 34.0457 13.142C34.3809 12.5653 34.5485 11.7315 34.5485 10.6406C34.5485 9.91619 34.4718 9.30398 34.3184 8.80398C34.1678 8.30114 33.9505 7.92045 33.6664 7.66193C33.3852 7.40057 33.0499 7.26989 32.6607 7.26989C32.0727 7.26989 31.611 7.55966 31.2758 8.1392C30.9406 8.71875 30.7715 9.55256 30.7687 10.6406C30.7687 11.3679 30.844 11.983 30.9945 12.4858C31.1479 12.9858 31.3653 13.3651 31.6465 13.6236C31.9278 13.8793 32.2658 14.0071 32.6607 14.0071Z",
    fill: "#5925DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19664_1472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk10);
export default __webpack_public_path__ + "static/media/uk_10.06f3479291ddd9f344f3066bb887d8db.svg";
export { ForwardRef as ReactComponent };